import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { SideMenuBar, BreadCrumbs } from '../components/SideMenuBar';
import { Link } from 'react-router-dom';
import { FaqContext } from '../context/FaqProvider';
import { useBrandDetails, EmotionBreakpoint } from 'dw-au-react-components';
import MobileMenu from '../components/SideMenuBar/MobileMenu';

const StyledContactBanner = styled.div`
	background: #00193c;
	.adc & {
		background: #074a67;
	}
	.vir & {
		background: #2d054e;
	}
	border-radius: 4px;
	> * {
		color: #fff;
	}
`;

const StyledFaqLayout = styled.div`
	.menu__wrapper {
		${EmotionBreakpoint('notMobile')} {
			position: sticky;
		}

		${EmotionBreakpoint('desktop')} {
			top: 80px;
		}

		${EmotionBreakpoint('tablet')} {
			top: 20px;
		}
	}

	.mobile-menu {
		background: #fafafa;
		border: 1px solid #e3e3e3;
		border-radius: 4px;
		margin-bottom: 40px;
		margin-top: 20px;
		padding: 20px;
	}
`;

function FaqMainLayout({ children }) {
	const { faqData, privacyAndTerms } = useContext(FaqContext);
	const brandData = useBrandDetails();

	return (
		<StyledFaqLayout className={brandData.tag}>
			<div className='container'>
				<div className='row'>
					<div className='breadcrumbs d-flex align-items-center p-15'>
						<Link
							to='/customer-services'
							className='submenu text-medium d-inline-block'
						>
							Help
						</Link>
						<BreadCrumbs faqData={faqData} privacyData={privacyAndTerms} />
					</div>
					<div className='d-flex mb-80 flex-md-row flex-column'>
						<div className='col-lg-3 col-sm-3 hidden-xs'>
							<SideMenuBar faqData={faqData} privacyData={privacyAndTerms} />
						</div>
						<div className='visible-xs col-xs-12'>
							<div className='mobile-menu'>
								<div className='subtitle mb-16'>Need Help?</div>
								<MobileMenu faqData={faqData} privacyData={privacyAndTerms} />
							</div>
						</div>
						<div className='col-lg-9 col-sm-9 col-xs-12'>{children}</div>
					</div>
					<StyledContactBanner className='text-center p-40 mb-80'>
						<div className='mb-12'>Haven’t found what you are looking for?</div>
						<h3
							className={`lower ${
								brandData.tag !== 'vir' ? 'font-oswald' : ''
							}`}
						>
							Get in contact with our customer service team
						</h3>
					</StyledContactBanner>
				</div>
			</div>
		</StyledFaqLayout>
	);
}

export default FaqMainLayout;
